module.exports = __webpack_public_path__ + "img/category1.29b2ca4f.svg";